import FieldProto from "../../../fields3/proto/field-proto"
import FieldsCollection from "../../../fields3/collection/base/fields-collection"
import Field1ToField2Converter from "../../../fields3/fields-converter-1-2"

export default function globalFields_getDynamicField(fieldId: ID) {
    let field: FieldProto | null = null
    _.some([
            gd.fields.task,
            gd.fields.event,
            gd.fields.timeReport,
            gd.fields.itemModel
        ],
        (fields: FieldsCollection)=>{
            if (fields.hasField(fieldId)) {
                field = fields.get(fieldId)
            }
            return !!field
        })

    // for deleted custom fields
    if (!field) {
        field = Field1ToField2Converter.convert(fieldId)
    }
    return field
}